import type { ReactNode } from 'react';
import { Link } from 'react-router';
import type { Crumb } from '@/components/page';
import { PageContainer, PageHeader } from '@/components/page';
import { Button } from '@/components/ui/button';
import { useDocumentTitle } from '@/lib/hooks';
import { StandaloneLayout } from './standalone-layout';

export function NotFoundContent({
  title = 'Page not found',
  description = 'The page you were looking for does not exist or has moved.',
  actions,
  breadcrumbs,
}: {
  title?: string;
  description?: string;
  /** Replaces the default link back to the server list. */
  actions?: ReactNode;
  breadcrumbs?: Crumb[];
}) {
  useDocumentTitle(title);
  return (
    <PageContainer>
      <PageHeader breadcrumbs={breadcrumbs} title={title} description={description} />
      <div className="flex flex-wrap gap-2">
        {actions ?? (
          <Button asChild variant="primary">
            <Link to="/">Back to your servers</Link>
          </Button>
        )}
      </div>
    </PageContainer>
  );
}

/** Not-found page for visitors who are not signed in, outside the app shell. */
export function NotFoundPage() {
  return (
    <StandaloneLayout>
      <NotFoundContent
        actions={
          <Button asChild variant="primary">
            <Link to="/login">Sign in</Link>
          </Button>
        }
      />
    </StandaloneLayout>
  );
}
